// extracted by mini-css-extract-plugin
module.exports = {"line":"Separation_line__akoJC","vertical":"Separation_vertical__suOWP","spin":"Separation_spin__To7Mk","loader":"Separation_loader__mA9rl"};